import React from "react";
import Drawer from "react-modern-drawer";
import { Link } from "gatsby";
import "react-modern-drawer/dist/index.css";
import logo from "../images/dealersyslongtransparent.png";
import digitalLeader from "../images/dealerlogo.png";
import Hamburger from "hamburger-react";
const MobileMenu = ({ location }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };
  return (
    <div className="w-full">
      <div className="  z-[1000] top-0 flex justify-between border-b px-5 pt-6 pb-3 shadow-sm fixed left-0 right-0 bg-white">
        <div className="cursor-pointer ">
          <Link to="/">
            <img
              src={
                (location !== undefined &&
                  location.pathname !== undefined &&
                  location.pathname == "/digital-dealer") ||
                location.pathname == "/contest-rules"
                  ? digitalLeader
                  : logo
              }
              alt=""
              className="w-48"
            />
          </Link>
        </div>
        <div className="flex self-center">
          <button onClick={toggleDrawer}>
            <Hamburger toggled={isOpen} color="#0170BA" />
          </button>
        </div>
      </div>

      <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction="right"
        style={{
          backgroundImage: `linear-gradient(rgba(63, 94, 251, 0.9), rgba(252, 70, 107, 0.9))`,
        }}
      >
        <div className="px-4 pt-24 text-white">
          <ul className="flex flex-col py-10">
            <li className="pb-6">
              <Link to="/providers">
                <span className="text-base capitalize transition-all text-dpurple hover:text-dpink NexaTextDemoLight ">
                  providers
                </span>
              </Link>
            </li>
            <li className="pb-6">
              <Link to="/nada">
                <span className="text-base capitalize transition-all text-dpurple hover:text-dpink NexaTextDemoLight ">
                  NADA
                </span>
              </Link>
            </li>

            <li className="pb-6">
              <Link to="/about">
                <span className="text-base capitalize transition-all text-dpurple hover:text-dpink NexaTextDemoLight ">
                  About Us
                </span>
              </Link>
            </li>
            <li className="pb-6">
              <Link to="/solutions">
                <span className="text-base capitalize transition-all text-dpurple hover:text-dpink NexaTextDemoLight ">
                  Solutions
                </span>
              </Link>
            </li>
            {/* <li className="pb-6">
              <Link to="/pricing">
                <span className="text-base capitalize transition-all text-dpurple hover:text-dpink NexaTextDemoLight ">
                  UCaaS Pricing
                </span>
              </Link>
            </li> */}
            <li className="pb-6">
              <Link to="/become-a-partner">
                <span className="text-base capitalize transition-all text-dpurple hover:text-dpink NexaTextDemoLight ">
                  Become a Partner
                </span>
              </Link>
            </li>
            <li>
              <Link to="/contact-us">
                <span className="text-base capitalize transition-all text-dpurple hover:text-dpink NexaTextDemoLight ">
                  Contact Us
                </span>
              </Link>
            </li>
          </ul>
        </div>
      </Drawer>
    </div>
  );
};

export default MobileMenu;
